import { mapGetters, mapActions } from 'vuex'
import { checkRoleManager } from '@/helpers/roles'
import OfferList from '@/components/offers/OfferList'
import TabHeader from '@/components/offers/TabHeader'
import Filters from '@/components/offers/filters'
import { checkCanEditContract } from '@/helpers/contracts'

var offers_mixin = {
  components: {
    OfferList,
    TabHeader,
    Filters
  },
  methods: {
    ...mapActions({
      getCurrentUser: 'auth/getUser',
      setCurrentPage: 'offers/setPage',
      setCurrentTab: 'offers/selectTab',
      setFilters: 'offers/setFilters',
      clearFilters: 'offers/clearFilters',
      setKeepFilters: 'offers/setKeepFilters',
      setSortOrder: 'offers/setSortOrder',
      setSortField: 'offers/setSortField',
      load: 'offers/loadOfferList',
      countByStatus: 'offers/countByStatus',
      reloadContractTemplates: 'contracts/loadContractTemplates',
      download: 'offers/download'
    }),

    tabChanged: function(tab){
      this.setCurrentPage(1)
      this.setCurrentTab(tab)
      this.reloadOffers()
    },

    filtersChanged: function(filters){
      if(this.offerList.loading) {
        return;
      }

      this.setFilters(filters)
      this.setCurrentPage(1)
      this.reloadOffers()
    },

    sortChanged: function(sortField, sortOrder){
      if(this.offerList.loading) {
        return;
      }

      this.setSortOrder(sortOrder)
      this.setSortField(sortField)
      this.reloadOffers()
    },

    pageChanged: function(page){
      if(this.offerList.loading) {
        return;
      }

      this.setCurrentPage(page)
      this.reloadOffers()
    },

    buildParams: function(){
      let params = { filters: this.filters,
                     page: this.page,
                     sort_field: this.offerList.sortField,
                     sort_order: this.offerList.sortOrder }
      if(this.status && this.status != 'all'){
        params['status'] = this.status
      }
      return params
    },

    exportOffersFile(fileType) {
      let params = this.buildParams();
      params['file_type'] = fileType;
      this.download(params);
    },

    reloadOffers: async function(){
      await this.load(this.buildParams())
      this.countByStatus(this.buildParams())
    },
    initFilters: function() {
      const filters = this.$route.params.filters;

      if(filters && filters.entity_id_in) {
        this.setFilters(this.$route.params.filters);
        this.setKeepFilters(true);
      }
    }
  },

  computed: {
    ...mapGetters({
      offerList: 'offers/offerList',
      numberByStatus: 'offers/numberByStatus',
      currentUser: 'auth/currentUser',
      status: 'offers/selectedTab',
      page: 'offers/currentPage',
      filters: 'offers/filters',
      keepFilters: 'offers/keepFilters',
      contractTemplates: 'contracts/contractTemplates'
    }),

    isManager: function() {
      return checkRoleManager(this.currentUser.role)
    },

    canEditContract: function() {
      return checkCanEditContract(this.currentUser, this.filters.entity_id_in)
    },

    selectedEntityId: function() {
      return this.filters.entity_id_in;
    }
  },
  created() {
    this.initFilters();
    if (this.keepFilters) {
      this.setKeepFilters(false)
    } else {
      this.clearFilters()
    }
  },
  mounted: async function(){
    await this.getCurrentUser();
    this.initTab();
  },
}

export default offers_mixin;



// WEBPACK FOOTER //
// ./src/mixin/offers.js